// The WHATWG HTML spec's "valid e-mail address" pattern — the same rule
// browsers use to validate <input type="email">. Full RFC 5322 compliance
// permits far stranger addresses (quoted strings, comments, etc.) than any
// real mail provider issues, so this is the practical, widely-adopted
// standard rather than the theoretical one.
// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const EMAIL_ERROR = "Enter a valid email address.";

export function isValidEmail(email) {
  const trimmed = email?.trim();
  if (!trimmed) return false;
  return EMAIL_PATTERN.test(trimmed);
}

export function getEmailError(email, fieldLabel = "Email") {
  const trimmed = email?.trim();
  if (!trimmed) return `${fieldLabel} is required`;
  if (!isValidEmail(trimmed)) {
    return EMAIL_ERROR;
  }
  return "";
}
